import React, { useState, useEffect } from 'react';
import { CSVLink } from 'react-csv';
import axios from 'axios';
// import JSZip from 'jszip';
// import JSZipUtils from 'jszip-utils';
// import { saveAs } from 'file-saver';
import QRCode from 'react-qr-code';
import Message from '../../utils/Message';
import Loader from '../../utils/Loader';
import CardImageModal from '../CardImageModal';
import { Table, DatePicker, Select, Button, Input } from 'antd';
import SummaryHeader from './SummaryHeader';
import ValidatorTable from './comp/ValidatorTable';
import { SearchOutlined, DownloadOutlined } from '@ant-design/icons';
import ValidationModal from './ValidationModal';
import moment from 'moment';
// import { LazyLoadImage } from 'react-lazy-load-image-component';

const ValidationTable = ({
  report,
  projectId,
  filter,
  setFilter,
  loading2,
  projectName,
  loggedInUser,
}) => {
  const { Option } = Select;
  const [rowsData, setRowsData] = useState({ columns: [], rows: [] });
  const [initialRowsData, setInitialRowsData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [errorMsg, setErrorMsg] = useState('');
  const [tableResponseRowData, setTableResponseRowData] = useState('');
  const [currentReportRowData, setCurrentReportRowData] = useState('');
  const [queryFields, setQueryFields] = useState([]);
  const [loading, setLoading] = useState(false);
  const [updated, setUpdated] = useState(false);
  const [imageKey, setImageKey] = useState('');
  const [type, setType] = useState('');
  const [searchText, setSearchText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);

  // console.log('loggedInUser validation', loggedInUser)
  const user = JSON.parse(localStorage.getItem('centralize-admin-data'));
  // console.log('user', user);
  const [urlData, setUrlData] = useState('');
  const [imageModal, setImageModal] = useState(false);
  const toggleImage = () => setImageModal(!imageModal);

  const today = new Date();
  const todayHours = `${today.getHours()}${today.getMinutes()}`;
  const todayDate = moment().format('YYYYMMDD');
  // this is for first load
  useEffect(() => {
    // if report and sidebar is clicked get data
    setCurrentReportRowData('');
    if (report) {
      // filter out status
      const queryFiltered = report.query
        ? report.query.filter(
            (e) => e.field === 'status' || e.field === 'Status'
          )
        : [];
      // add status field if it's required in req.body
      if (queryFiltered.length) {
        const newAr = [];
        report.query.forEach((e) => {
          if (e.field === 'status') {
            e.value = e.dropdown[0];
          }
          if (e.field) {
            newAr.push(e);
          }
        });
        setQueryFields(newAr);
        setLoading(true);

        let newArr = {};
        queryFiltered.forEach((e) => {
          if (e.dropdown[0]) {
            newArr[e.field] = e.dropdown[0] ? e.dropdown[0] : '';
          }
        });
        newArr.token = user.accessToken;
        newArr.campaignId = loggedInUser ? loggedInUser.campaignId : '';
        // get data from client

        if (newArr.token && Object.values(newArr).length) {
          // console.log('counter', counter)

          // console.log('get query data from client 1');
          axios
            .post(report.endpoint, newArr)
            .then((data) => {
              if (data.data) {
                setTableResponseRowData(data.data.data);
                setLoading(false);
                setErrorMsg('');
                // set initial load to false
                setUpdated(false);
              }
            })
            .catch((err) => {
              setTableResponseRowData('');
              setErrorMsg(
                err.response.data
                  ? err.response.data.error || err.response.data.message
                  : ''
              );
              setLoading(false);
              setUpdated(false);
            });
        }
      } else {
        // check query exist or not
        const newArr2 = [];
        report.query.forEach((e) => {
          if (e.field) {
            newArr2.push(e);
          }
        });
        setQueryFields(newArr2);
        setLoading(true);
        // get data from client
        axios
          .post(report.endpoint, {
            token: user.accessToken,
            campaignId: loggedInUser ? loggedInUser.campaignId : '',
          })
          .then((data) => {
            if (data.data) {
              setTableResponseRowData(data.data.data);
              setLoading(false);
              setErrorMsg('');
            }
          })
          .catch((err) => {
            setTableResponseRowData('');
            setErrorMsg(
              err.response.data
                ? err.response.data.error || err.response.data.message
                : ''
            );
            setLoading(false);
          });
      }
    }
  }, [report, user.accessToken]);

  // get data after filter is clicked
  useEffect(() => {
    // console.log('data update here filter ======');
    if (filter && queryFields) {
      // console.log('loading 2');
      let newArr = {};
      queryFields.forEach((e) => {
        if (!e.value) return;
        newArr[e.field] = e.value;
      });

      newArr.token = user.accessToken;
      newArr.campaignId = loggedInUser ? loggedInUser.campaignId : '';
      setLoading(true);

      if (newArr.token && Object.values(newArr).length) {
        // console.log('get query data from client 3');
        axios
          .post(report.endpoint, newArr)
          .then((data) => {
            if (data.data) {
              setTableResponseRowData(data.data.data);
              setLoading(false);
              setErrorMsg('');
            }
          })
          .catch((err) => {
            setErrorMsg(
              err.response.data
                ? err.response.data.error || err.response.data.message
                : ''
            );
            setLoading(false);
          });
      }
    }
  }, [filter, queryFields, report, user.accessToken]);

  // console.log('report', report);

  const csvFormatGetter = (tableResponseData) => {
    const hasInvoiceNo = report.header.filter(
      (e) => e.type === 'invoiceNumber'
    );
    // console.log('tableResponseData', tableResponseData);
    const newCsvData = tableResponseData.map((each, idx) => {
      let data = { ...each };

      data.longText = data.message;
      // console.log('data', data);

      if (data.message) {
        data.message = '';
      }
      // console.log('hasInvoiceNo', hasInvoiceNo);
      if (hasInvoiceNo) {
        hasInvoiceNo.forEach((invoice, i) => {
          data[invoice.field] = `\t${each[invoice.field]}`;
        });
      }
      return data;
    });

    return newCsvData;
  };

  useEffect(() => {
    // console.log('tableResponseRowData updated ======');
    if (report && !tableResponseRowData.length) {
      let data = { columns: [], rows: [] };
      setRowsData(data);
    }

    if (report && tableResponseRowData) {
      const column = report.header
        ? report.header.map((each) => {
            // console.log('each', each.width);
            return {
              title: each.label || each.title,
              dataIndex: each.field || each.key,
              key: each.field || each.key,
              label: each.label || each.title,
              sortDirections: ['descend', 'ascend'],
              width: 500,
              sorter: (a, b) => {
                if (/^\d/.test(a[each.field || each.key])) {
                  return a[each.field || each.key] - b[each.field || each.key];
                } else {
                  return a[each.field || each.key]
                    ? a[each.field || each.key].localeCompare(
                        b[each.field || each.key]
                      )
                    : a[each.field || each.key];
                }
              },
            };
          })
        : [];

      let data = { columns: column, rows: [] };

      const hasImage = report.header.filter((e) => e.type === 'image');
      const hasQrCode = report.header.filter((e) => e.type === 'qrCode');

      let imageName = '';

      if (
        report.reportType === 'Action' ||
        report.reportType === 'action-without-receipt' ||
        report.reportType === 'receipt-validation'
      ) {
        // console.log('tableResponseRowData', tableResponseRowData);
        const newD = tableResponseRowData.map((each, idx) => {
          let data = { ...each };

          data.longText = data.message;
          // console.log('data', data);

          if (data.message) {
            data.message = '';
          }

          if (hasImage) {
            // get image  object key
            hasImage.forEach((image, i) => {
              imageName = image.field;

              data[imageName] = '';
              setType(each.name ? each.name : data[imageName]);
              setUrlData(
                Array.isArray(each[imageName])
                  ? each[imageName]
                  : data[image.field].props
                  ? data[image.field].props.src
                  : data[image.field]
              );
            });
          }
          if (hasQrCode) {
            hasQrCode.forEach((qr, idx1) => {
              let qrCodeText = qr.field;

              if (data[qr.field]) {
                data[qrCodeText] = (
                  <QRCode
                    id={'QrCode' + idx1}
                    size={256}
                    style={{ height: 'auto', maxWidth: '100%', width: '100%' }}
                    value={
                      data[qr.field].props
                        ? data[qr.field].props.value
                        : data[qr.field]
                    }
                    viewBox={`0 0 256 256`}
                    onClick={() => {
                      onImageDownload(qrCodeText, idx1);
                    }}
                  />
                );
              }
            });
          }
          data._id = each._id || each.id;
          data.id = (
            <div
              style={{ cursor: 'pointer' }}
              onClick={() => getReport(each, idx)}
            >
              <i className="far fa-edit"></i>
            </div>
          );
          return data;
        });
        data.rows = newD ? newD : [];
      } else {
        // render image url

        if (hasImage) {
          const newD = tableResponseRowData.map((each) => {
            // console.log('each', each);
            let data = { ...each };
            // has image
            // get image  object key
            if (hasImage) {
              // get image  object key
              hasImage.forEach((image, i) => {
                imageName = image.field;
                data[imageName] = '';

                setType(each.name ? each.name : data[imageName]);
                setUrlData(
                  data[image.field].props
                    ? data[image.field].props.src
                    : data[image.field]
                );
              });
            }
            if (hasQrCode) {
              hasQrCode.forEach((qr, idx1) => {
                let qrCodeText = qr.field;

                if (data[qr.field]) {
                  data[qrCodeText] = (
                    <QRCode
                      id={'QrCode' + idx1}
                      size={256}
                      style={{
                        height: 'auto',
                        maxWidth: '100%',
                        width: '100%',
                      }}
                      value={
                        data[qr.field].props
                          ? data[qr.field].props.value
                          : data[qr.field]
                      }
                      viewBox={`0 0 256 256`}
                      onClick={() => {
                        onImageDownload(qrCodeText, idx1);
                      }}
                    />
                  );
                }
              });
            }
            return data;
          });
          data.rows = newD ? newD : [];
        } else {
          data.rows = tableResponseRowData ? tableResponseRowData : [];
        }
      }
      setImageKey(imageName);
      setRowsData({ columns: data.columns, rows: data.rows });
      setInitialRowsData(data.rows);

      const newCsvData = csvFormatGetter(tableResponseRowData);
      // console.log('data', data);
      setCsvData(newCsvData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [report, tableResponseRowData, updated]);

  // get report row data when edit button clicked
  function getReport(curReport, idx) {
    window.scrollTo(0, 0);
    setCurrentIndex(idx);
    setCurrentReportRowData(curReport);
    setUpdated(false);
  }

  function queryObjectChange(value, index) {
    // reset the filter and isUpdated
    setFilter(false);
    setUpdated(false);
    let newArr = [...queryFields];
    newArr[index].value = value;
    setQueryFields(newArr);
  }

  function clickFilter() {
    // if filter return new table data
    setFilter(true);
    setUpdated(true);
    setCurrentReportRowData('');
  }

  const onDateChange = (value, index) => {
    setFilter(false);
    setUpdated(false);
    let newArr = [...queryFields];
    newArr[index].value = value;
    setQueryFields(newArr);
  };

  function filterByValue(array, value) {
    return array.filter((data) => {
      return (
        JSON.stringify(data).toLowerCase().indexOf(value.toLowerCase()) !== -1
      );
    });
  }

  const onSearch = (e) => {
    if (!searchText) return;
  };

  function searchBarOnChange(value) {
    setSearchText(value);

    if (!value) {
      setSearchText('');
      let newTableData = { ...rowsData };
      newTableData.rows = initialRowsData;
      setRowsData(newTableData);
    } else {
      const filteredData = filterByValue(initialRowsData, value);
      if (filteredData.length) {
        let newTableData = { ...rowsData };
        newTableData.rows = filteredData;
        setRowsData(newTableData);

        const newCsvData = csvFormatGetter(filteredData);
        setCsvData(newCsvData);
      } else {
        let newTableData = { ...rowsData };
        newTableData.rows = [];
        setRowsData(newTableData);
        setCsvData([]);
      }
    }
  }

  function validateNow() {
    // console.log('check out the double after validate');
    const allArr = tableResponseRowData;
    if (allArr.length) {
      const filterArr = allArr.filter(
        (arr) =>
          (arr.id || arr._id) !==
          (currentReportRowData.id || currentReportRowData._id)
      );
      // filter and approve and add the latest array as current data
      //setRowsData
      const dataRows = rowsData.rows;
      const filteredRows = dataRows.filter(
        (arr) =>
          (arr.id || arr._id) !==
          (currentReportRowData.id || currentReportRowData._id)
      );
      let newTableData = { ...rowsData };
      newTableData.rows = filteredRows;
      setRowsData(newTableData);
      setTableResponseRowData(filterArr);

      setCurrentReportRowData(filterArr[0]);
    }
  }

  function nextSlide() {
    // console.log('click next', currentIndex, tableResponseRowData.length);
    if (currentIndex + 1 < tableResponseRowData.length) {
      const increment = currentIndex + 1;
      setCurrentReportRowData(tableResponseRowData[increment]);
      setCurrentIndex(increment);
    }
  }

  const previousSlide = () => {
    // console.log('click back', currentIndex);
    if (currentIndex > 0) {
      const decrement = currentIndex - 1;
      setCurrentReportRowData(tableResponseRowData[decrement]);
      setCurrentIndex(decrement);
    }
  };

  const onImageDownload = (name, idx) => {
    const svg = document.getElementById('QrCode' + idx);
    const svgData = new XMLSerializer().serializeToString(svg);
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      canvas.width = img.width;
      canvas.height = img.height;
      ctx.drawImage(img, 0, 0);
      const pngFile = canvas.toDataURL('image/png');

      toggleImage();
      setType(name);
      setUrlData(pngFile);
    };
    img.src = `data:image/svg+xml;base64,${btoa(svgData)}`;
  };

  // console.log('tableResponseRowData', tableResponseRowData);
  // console.log('queryFields', queryFields);

  return (
    <div>
      <>
        {!report ? (
          <Message color="warning">Please select report to display.</Message>
        ) : (
          <>
            {errorMsg ? <Message color="danger"> {errorMsg} </Message> : null}

            <div>
              <CardImageModal
                modal={imageModal}
                toggle={toggleImage}
                urlData={urlData}
                type={type}
              />

              {loading ? (
                <Loader />
              ) : (
                <>
                  {loading2 ? (
                    <Loader />
                  ) : report ? (
                    <SummaryHeader
                      report={report}
                      loggedInUser={loggedInUser}
                      queryFields={queryFields}
                      filter={filter}
                    />
                  ) : (
                    ''
                  )}
                  {report && report.reportType === 'receipt-validation' ? (
                    <>
                      <ValidatorTable projectId={projectId} />
                    </>
                  ) : null}
                  {/* todo show the validation table */}

                  {currentReportRowData ? (
                    <div
                      style={{
                        background: '#fff',
                        padding: '2rem',
                        borderRadius: '10px',
                        marginBottom: '4rem',
                        height:
                          report.reportType === 'action-without-receipt'
                            ? 'auto'
                            : '100vh',
                      }}
                    >
                      <ValidationModal
                        loggedInUser={loggedInUser}
                        currentReportRowData={currentReportRowData}
                        projectId={projectId}
                        accessToken={user && user.accessToken}
                        report={report}
                        imageKey={imageKey}
                        validateNow={validateNow}
                        nextSlide={nextSlide}
                        previousSlide={previousSlide}
                        currentIndex={currentIndex}
                        lastIndex={tableResponseRowData.length}
                        setError={setErrorMsg}
                      />
                    </div>
                  ) : null}

                  {rowsData && rowsData.columns.length ? (
                    <div
                      style={{
                        background: '#fff',
                        padding: '1rem 2rem 1rem 2rem',
                        borderRadius: '10px',
                      }}
                    >
                      <div className="d-flex justify-content-between pb-3 ">
                        <div className="d-flex flex-wrap py-3">
                          <Input
                            prefix={<SearchOutlined />}
                            style={{
                              width: 200,
                              marginRight: '1rem',
                            }}
                            onChange={(e) => searchBarOnChange(e.target.value)}
                            placeholder="Search"
                            value={searchText}
                            onPressEnter={onSearch}
                          />
                          {queryFields.length
                            ? queryFields.map((query, i) => {
                                if (query.field) {
                                  return (
                                    <div key={i + 1}>
                                      {query.type === 'dropdown' ? (
                                        <div className="mx-1">
                                          <Select
                                            onChange={(e) =>
                                              queryObjectChange(e, i)
                                            }
                                            defaultValue={query.label}
                                            style={{
                                              width: 150,
                                            }}
                                            value={query.value}
                                          >
                                            {query.dropdown.map((e, idx) => {
                                              return (
                                                <Option value={e} key={idx}>
                                                  {e}
                                                </Option>
                                              );
                                            })}
                                          </Select>
                                        </div>
                                      ) : (
                                        <div>
                                          {query.type === 'date' && (
                                            <div
                                              style={{ marginRight: '1rem' }}
                                            >
                                              <DatePicker
                                                onChange={(e) =>
                                                  onDateChange(e, i)
                                                }
                                                value={query.value}
                                                placeholder={query.label}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  );
                                }

                                return null;
                              })
                            : null}

                          {queryFields.length > 0 ? (
                            <>
                              <Button
                                onClick={() => clickFilter()}
                                style={{
                                  backgroundColor: '#051D49',
                                  color: '#fff',
                                }}
                              >
                                Filter
                              </Button>
                            </>
                          ) : null}
                        </div>

                        <div className="py-3">
                          <Button
                            icon={<DownloadOutlined />}
                            size={'middle'}
                            style={{
                              backgroundColor: '#051D49',
                              color: '#fff',
                            }}
                          >
                            <CSVLink
                              data={
                                csvData &&
                                csvData.map((each) => {
                                  return {
                                    ...each,
                                    id:
                                      queryFields?.find(
                                        (eac) =>
                                          eac.field === 'status' ||
                                          each.field === 'action'
                                      )?.value || each.id,
                                  };
                                })
                              }
                              filename={`${projectName && projectName}-${
                                report && report.name
                              }-${todayDate}-${todayHours}.csv`}
                              style={{ padding: '1rem' }}
                              headers={rowsData && rowsData.columns}
                            >
                              Download Report
                            </CSVLink>
                          </Button>
                        </div>
                      </div>
                      <Table
                        rowClassName={(record, index) =>
                          index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                        }
                        columns={rowsData ? rowsData.columns : []}
                        dataSource={
                          rowsData
                            ? rowsData.rows.map((el, idx) => ({
                                key: idx,
                                ...el,
                              }))
                            : []
                        }
                        bordered
                        pagination={{ position: ['bottomLeft'] }}
                        scroll={{ x: 1000 }}
                      />
                      <div>
                        {rowsData && rowsData.rows.length
                          ? `1 of ${rowsData.rows.length}`
                          : ''}
                      </div>
                    </div>
                  ) : null}
                </>
              )}
            </div>
          </>
        )}
      </>
    </div>
  );
};

export default ValidationTable;
